/** Referência da data dos pedidos */
export interface PedidoReferenciaData {
    id: number;
    nome: string;
    iconClass: string;
}

export const referenciaDataEmissao: PedidoReferenciaData = {
    id: 1,
    nome: 'Emissão',
    iconClass: 'far fa-calendar-alt'
};
export const referenciaDataConfirmacao: PedidoReferenciaData = {
    id: 2,
    nome: 'Confirmação',
    iconClass: 'far fa-calendar-check'
};
export const referenciaDataAnaliseFinanceiro: PedidoReferenciaData = {
    id: 3,
    nome: 'Análise Financeiro',
    iconClass: 'fas fa-money-check-alt'
};
export const referenciaDataInicioGepFinanceiro: PedidoReferenciaData = {
    id: 4,
    nome: 'Início GEP Financeiro',
    iconClass: 'fas fa-money-bill-wave'
};
export const referenciaDataTerminoGepFinanceiro: PedidoReferenciaData = {
    id: 5,
    nome: 'Término GEP Financeiro',
    iconClass: 'fas fa-money-bill-wave'
};
export const referenciaDataInicioAguardandoProducao: PedidoReferenciaData = {
    id: 6,
    nome: 'Início Aguardando Produção',
    iconClass: 'fas fa-clock'
};
export const referenciaDataTerminoAguardandoProducao: PedidoReferenciaData = {
    id: 7,
    nome: 'Término Aguardando Produção',
    iconClass: 'fas fa-clock'
};
export const referenciaDataInicioGepComercial: PedidoReferenciaData = {
    id: 8,
    nome: 'Início GEP Comercial',
    iconClass: 'fas fa-user-check'
};
export const referenciaDataTerminoGepComercial: PedidoReferenciaData = {
    id: 9,
    nome: 'Término GEP Comercial',
    iconClass: 'fas fa-user-check'
};
export const referenciaDataLiberadoExpedicao: PedidoReferenciaData = {
    id: 10,
    nome: 'Liberado Expedição',
    iconClass: 'fas fa-truck-loading'
};
export const referenciaDataInicioExpedicao: PedidoReferenciaData = {
    id: 11,
    nome: 'Início Expedição',
    iconClass: 'fas fa-truck'
};
export const referenciaDataTerminoExpedicao: PedidoReferenciaData = {
    id: 12,
    nome: 'Término Expedição',
    iconClass: 'fas fa-truck'
};
export const referenciaDataInicioGepExpedicao: PedidoReferenciaData = {
    id: 13,
    nome: 'Início GEP Expedição',
    iconClass: 'fas fa-truck'
};
export const referenciaDataTerminoGepExpedicao: PedidoReferenciaData = {
    id: 14,
    nome: 'Término GEP Expedição',
    iconClass: 'fas fa-truck'
};
export const referenciaDataLiberadoFaturamento: PedidoReferenciaData = {
    id: 15,
    nome: 'Liberado Faturamento',
    iconClass: 'fas fa-file-invoice-dollar'
};
export const referenciaDataFaturamento: PedidoReferenciaData = {
    id: 16,
    nome: 'Faturamento',
    iconClass: 'fas fa-file-invoice'
};
export const referenciaDataInicioGepFaturamento: PedidoReferenciaData = {
    id: 17,
    nome: 'Início GEP Faturamento',
    iconClass: 'fas fa-file-invoice'
};
export const referenciaDataTerminoGepFaturamento: PedidoReferenciaData = {
    id: 18,
    nome: 'Término GEP Faturamento',
    iconClass: 'fas fa-file-invoice'
};
export const referenciaDataLiberadoColeta: PedidoReferenciaData = {
    id: 19,
    nome: 'Liberado Coleta',
    iconClass: 'fas fa-box-open'
};
export const referenciaDataColeta: PedidoReferenciaData = {
    id: 20,
    nome: 'Coleta',
    iconClass: 'fas fa-box'
};
export const referenciaDataInicioGepColeta: PedidoReferenciaData = {
    id: 21,
    nome: 'Início GEP Coleta',
    iconClass: 'fas fa-box'
};
export const referenciaDataTerminoGepColeta: PedidoReferenciaData = {
    id: 22,
    nome: 'Término GEP Coleta',
    iconClass: 'fas fa-box'
};
export const referenciaDataInicioGepTransportadora: PedidoReferenciaData = {
    id: 23,
    nome: 'Início GEP Transportadora',
    iconClass: 'fas fa-truck'
};
export const referenciaDataTerminoGepTransportadora: PedidoReferenciaData = {
    id: 24,
    nome: 'Término GEP Transportadora',
    iconClass: 'fas fa-truck'
};
export const referenciaDataPrevisaoEntrega: PedidoReferenciaData = {
    id: 25,
    nome: 'Previsão Entrega',
    iconClass: 'fas fa-calendar-day'
};
export const referenciaDataEntrega: PedidoReferenciaData = {
    id: 26,
    nome: 'Entrega',
    iconClass: 'fas fa-calendar-check'
};
export const referenciaDataNaoLiberado: PedidoReferenciaData = {
    id: 27,
    nome: 'Não Liberado',
    iconClass: 'fas fa-ban'
};
export const referenciaDataLiberado: PedidoReferenciaData = {
    id: 28,
    nome: 'Liberado',
    iconClass: 'fas fa-check-circle'
};
export const referenciaDataIntegracaoErp: PedidoReferenciaData = {
    id: 29,
    nome: 'Integração ERP',
    iconClass: 'fas fa-plug'
};
export const referenciaDataIntegracaoEcommerce: PedidoReferenciaData = {
    id: 30,
    nome: 'Integração E-commerce',
    iconClass: 'fas fa-shopping-cart'
};

export const pedidoReferenciasData: PedidoReferenciaData[] = [
    referenciaDataEmissao,
    referenciaDataConfirmacao,
    referenciaDataAnaliseFinanceiro,
    referenciaDataInicioGepFinanceiro,
    referenciaDataTerminoGepFinanceiro,
    referenciaDataInicioAguardandoProducao,
    referenciaDataTerminoAguardandoProducao,
    referenciaDataInicioGepComercial,
    referenciaDataTerminoGepComercial,
    referenciaDataLiberadoExpedicao,
    referenciaDataInicioExpedicao,
    referenciaDataTerminoExpedicao,
    referenciaDataInicioGepExpedicao,
    referenciaDataTerminoGepExpedicao,
    referenciaDataLiberadoFaturamento,
    referenciaDataFaturamento,
    referenciaDataInicioGepFaturamento,
    referenciaDataTerminoGepFaturamento,
    referenciaDataLiberadoColeta,
    referenciaDataColeta,
    referenciaDataInicioGepColeta,
    referenciaDataTerminoGepColeta,
    referenciaDataInicioGepTransportadora,
    referenciaDataTerminoGepTransportadora,
    referenciaDataPrevisaoEntrega,
    referenciaDataEntrega,
    referenciaDataNaoLiberado,
    referenciaDataLiberado,
    referenciaDataIntegracaoErp,
    referenciaDataIntegracaoEcommerce
];
